import { Controller } from "stimulus"
import toastr from "toastr"

export default class extends Controller {
  static targets = ["form", "submitButton"]

  connect() {
    // Configure toastr defaults (optional)
    toastr.options = {
      positionClass: "toast-bottom-right",
      timeOut: 4000,
      closeButton: true,
      progressBar: true
    }
  }

  submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const submitButton = this.submitButtonTarget
    const spinner = submitButton.querySelector(".loading")
    const submitText = submitButton.querySelector(".submit")

    // 🔄 Show loading state
    submitButton.disabled = true
    spinner.style.display = "inline-block"
    submitText.style.display = "none"

    const formData = new FormData(form)

    fetch(form.action, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: formData
    })
      .then(async (response) => {
        const data = await response.json()
        if (response.ok) {
          toastr.success(data.message || "You’ve successfully subscribed!")
          form.reset()

        //   // ✅ Close modal if within one
        //   const modalEl = this.element.closest(".popup-modal")
        //   if (modalEl) {
        //     //   const modal = bootstrap.Modal.getInstance(modalEl)
        //       console.log(modal)
        //     // if (modal) modal.hide()
        //     modalEl.hide()
        //   }
        } else {
          toastr.error(data.errors?.join(", ") || "Something went wrong. Please try again.")
        }
      })
      .catch(() => {
        toastr.error("Network error. Please try again.")
      })
      .finally(() => {
        // 🔁 Reset button state
        submitButton.disabled = false
        spinner.style.display = "none"
        submitText.style.display = "inline"
      })
  }
}